import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { LogoutService } from '@service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'logout-component',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./logout.component.scss'],
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  router: Router;
  logoutService: LogoutService;
  seconds = 3;
  constructor(router: Router, logoutService: LogoutService) {
    this.router = router;
    this.logoutService = logoutService;
  }

  async ngOnInit() {
    await lastValueFrom(this.logoutService.logout());
    const timeout = setInterval(async () => {
      this.seconds--;
      if (this.seconds === 0) {
        clearTimeout(timeout);
        await this.login();
      }
    }, 1000);
  }

  async login(): Promise<void> {
    await this.router.navigate(['/login']);
  }
}
